enum OrderDetailsChangesApprovalOptionType {
  BY_DEALER = "BY_DEALER",
  BY_DISPATCHER = "BY_DISPATCHER",
  BY_OPERATOR = "BY_OPERATOR",
}

export default OrderDetailsChangesApprovalOptionType;
